// In src/components/nodes/nodeTypes.js
import TriggerNode from './TriggerNode';
import AIModelNode from './AIModelNode';
import OutputNode from './OutputNode';
import SendEmailNode from './SendEmailNode';
import HumanInputNode from './HumanInputNode';
import ConditionNode from './ConditionNode';
import PostNode from './PostNode';
import ParserNode from './ParserNode';
import ChatNode from './ChatNode';
import ResearchNode from './ResearchNode';
import FirecrawlNode from './FirecrawlNode';
import UnsplashNode from './UnsplashNode';
import APICallNode from './APICallNode';
import { StickyNote, TextAnnotation, Shape } from '../AnnotationTools';
import { 
  SentimentAnalysisNode, 
  SummaryGeneratorNode, 
  ExtractInformationNode, 
  WriteArticleNode, 
  OptimizeSEONode 
} from './SpecializedAINodes';

export const nodeTypes = {
  trigger: TriggerNode,
  aiModel: AIModelNode,
  output: OutputNode,
  humanInput: HumanInputNode,
  sendEmail: SendEmailNode,
  condition: ConditionNode,
  post: PostNode,
  sentimentAnalysis: SentimentAnalysisNode,
  summaryGenerator: SummaryGeneratorNode,
  extractInformation: ExtractInformationNode,
  writeArticle: WriteArticleNode,
  optimizeSEO: OptimizeSEONode,
  research: ResearchNode,
  parser: ParserNode,
  firecrawl: FirecrawlNode,
  unsplash: UnsplashNode,
  chat: ChatNode,
  APICall: APICallNode,
  stickyNote: StickyNote,
  textAnnotation: TextAnnotation,
  shape: Shape
};

export default nodeTypes;